"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConsentCookieSet = exports.readConsentFromCookie = exports.storeConsentToCookie = void 0;
const cookie_1 = require("@uxf/core/cookie");
const COOKIE_NAME = "cookieConsent";
const COOKIE_TTL = 3600 * 24 * 90;
const storeConsentToCookie = (consent) => {
    if (typeof window === "undefined") {
        throw new Error("The 'storeConsentToCookie' method cannot be called on server side.");
    }
    cookie_1.Cookie.create().set(COOKIE_NAME, btoa(JSON.stringify(consent)), COOKIE_TTL);
};
exports.storeConsentToCookie = storeConsentToCookie;
const readConsentFromCookie = (ctx) => {
    const cookieConsent = cookie_1.Cookie.create(ctx).get(COOKIE_NAME);
    return JSON.parse(atob(cookieConsent || "") || "{}");
};
exports.readConsentFromCookie = readConsentFromCookie;
const isConsentCookieSet = (ctx) => {
    const cookieConsent = cookie_1.Cookie.create(ctx).get(COOKIE_NAME);
    const parsedConsent = JSON.parse(atob(cookieConsent || "") || "{}");
    return (typeof parsedConsent.ad_storage === "boolean" &&
        typeof parsedConsent.analytics_storage === "boolean" &&
        typeof parsedConsent.personalization_storage === "boolean");
};
exports.isConsentCookieSet = isConsentCookieSet;
